import IFilterCategory from "./IFilterCategory";

export const FILTER_CATEGORIES: IFilterCategory[] = [
  { id: 1, name: "Basic" },
  { id: 2, name: "Comparison" },
  { id: 3, name: "Equivalence" },
  { id: 4, name: "Field Comparison" },
  { id: 5, name: "Date & Time" },
  { id: 6, name: "String" },
];